function Main({children}) {
    return (
        <main className="name">
            {children}
        </main>
    )
}

export default Main

